import React, { useState } from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom';
import './AddProductForm.css';

const EditProductModal = ({ product, onClose, onUpdate }) => {
  const [activeTab, setActiveTab] = useState('main');
  const [title, setTitle] = useState(product.title || '');
  const [description, setDescription] = useState(product.description || '');
  const [district, setDistrict] = useState(product.district || '');
  const [contactPhone, setContactPhone] = useState(product.phone || '');
  const [mainImage, setMainImage] = useState(product.mainImage || null);
  const [images, setImages] = useState(product.images || []);
  const [removedImages, setRemovedImages] = useState([]); // New state for tracking removed images
  const [newImages, setNewImages] = useState([]);
  const [prices, setPrices] = useState(product.prices || {
    priceOneHour: '',
    priceTwoHours: '',
    priceTravelOneHour: '',
    priceTravelTwoHours: '',
    priceWholeNight: '',
  });
  const [characteristics, setCharacteristics] = useState(product.characteristics || {
    age: '',
    height: '',
    weight: '',
    breast: '',
    shoeSize: '',
    clothingSize: '',
    districtL: '',
  });
  const priceLabels = {
    priceOneHour: 'Цена за 1 час',
    priceTwoHours: 'Цена за 2 часа',
    priceTravelOneHour: 'Цена за поездку (1 час)',
    priceTravelTwoHours: 'Цена за поездку (2 часа)',
    priceWholeNight: 'Цена за ночь',
  };

  const characteristicLabels = {
    age: 'Возраст',
    height: 'Рост (см)',
    weight: 'Вес (кг)',
    breast: 'Размер груди',
    shoeSize: 'Размер обуви',
    clothingSize: 'Размер одежды',
    district: 'Район',
  };
  const [preferences, setPreferences] = useState(product.preferences || {});
  const [message, setMessage] = useState('');
  // Метки для предпочтений
  const preferenceOptions = [
    {
      category: 'Что будет', options: ['Классический секс', 'Минет в презервативе', 'Минет без резинки', 'Минет глубокий', 'Куннилингус', 'Окончание на грудь', 'Окончание на лицо', 'Окончание в рот', 'Целуюсь', 'Госпожа', 'Рабыня', 'Классический массаж',
        '      Расслабляющий массаж', 'Урологический массаж', 'Эротический массаж', 'Профессиональный массаж', 'Стриптиз', 'Ролевые игры', 'Эскорт', 'Анальный секс', 'Золотой дождь', 'Страпон', 'Групповой секс', 'Легкое садо/мазо', 'Игрушки', 'Услуги семейным парам']
    },
    {
      category: 'Что может быть!', options: ['Классический секс', 'Минет в презервативе', 'Минет без резинки', 'Минет глубокий', 'Куннилингус', 'Окончание на грудь', 'Окончание на лицо', 'Окончание в рот', 'Целуюсь', 'Госпожа', 'Рабыня', 'Классический массаж',
        '      Расслабляющий массаж', 'Урологический массаж', 'Эротический массаж', 'Профессиональный массаж', 'Стриптиз', 'Ролевые игры', 'Эскорт', 'Анальный секс', 'Золотой дождь', 'Страпон', 'Групповой секс', 'Легкое садо/мазо', 'Игрушки', 'Услуги семейным парам']
    },
  ];

  // Обработчик для изменения предпочтений
  const handlePreferenceChange = (category, option) => {
    setPreferences((prevState) => {
      // Получаем объект категории или создаём новый, если его ещё нет
      const categoryPreferences = prevState[category] || { options: [], prices: {} };
  
      // Работаем с массивом options
      const updatedOptions = categoryPreferences.options.includes(option)
        ? categoryPreferences.options.filter((item) => item !== option) // Убираем опцию, если она уже выбрана
        : [...categoryPreferences.options, option]; // Добавляем опцию, если её нет
  
      return {
        ...prevState,
        [category]: {
          ...categoryPreferences,
          options: updatedOptions, // Обновляем массив опций
        },
      };
    });
  };

  const handleRemoveExistingImage = (index) => {
    const imageToRemove = images[index];
    setRemovedImages((prev) => [...prev, imageToRemove]); // Track the removed image
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const handleRemoveMainImage = () => {
    if (mainImage && typeof mainImage === 'string') {
      setRemovedImages((prev) => [...prev, mainImage]); // Track the main image for removal
    }
    setMainImage(null);
  };

  const handleAddNewImages = (e) => {
    setNewImages((prevImages) => [...prevImages, ...Array.from(e.target.files)]);
  };

  const handleSave = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('district', district);
    formData.append('phone', contactPhone);

    if (mainImage && typeof mainImage !== 'string') {
      formData.append('mainImage', mainImage);
    } else if (!mainImage) {
      formData.append('removeMainImage', true);
    }

    formData.append('prices', JSON.stringify(prices));
    formData.append('characteristics', JSON.stringify(characteristics));
    formData.append('preferences', JSON.stringify(preferences));

    // Отправка текущих изображений
    images.forEach((image) => {
      if (typeof image === 'string') {
        formData.append('existingImages', image);
      } else {
        formData.append('images', image);
      }
    });

    // Отправка новых изображений
    newImages.forEach((image) => formData.append('images', image));

    // Отправка удаленных изображений
    if (removedImages.length > 0) {
      formData.append('removedImages', JSON.stringify(removedImages));
    }

    try {
      const response = await axios.put(`/api/products/${product.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      const updatedProduct = response.data.data;
      setMessage('Товар успешно обновлён!');
      onUpdate(updatedProduct);
      onClose();
    } catch (error) {
      console.error('Ошибка при обновлении товара:', error);
      setMessage('Ошибка при обновлении товара.');
    }
  };



  const modalContent = (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content add-product-form" onClick={(e) => e.stopPropagation()}>
        <div className="tabs">
          <button className={`glow-on-hover2 ${activeTab === 'main' ? 'active' : ''}`} onClick={() => setActiveTab('main')}>Основные</button>
          <button className={`glow-on-hover2 ${activeTab === 'prices' ? 'active' : ''}`} onClick={() => setActiveTab('prices')}>Цены</button>
          <button className={`glow-on-hover2 ${activeTab === 'characteristics' ? 'active' : ''}`} onClick={() => setActiveTab('characteristics')}>Характеристики</button>
          <button className={`glow-on-hover2 ${activeTab === 'preferences' ? 'active' : ''}`} onClick={() => setActiveTab('preferences')}> Основное и Дополнительно </button>
        </div>

        <form onSubmit={handleSave}>
          {activeTab === 'main' && (
            <div className="tab-content">
              <h2>Редактировать товар</h2>
              <label>Имя:</label>
              <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />

              <label>Послание посетителю:</label>
              <textarea value={description} onChange={(e) => setDescription(e.target.value)} required />

              <label>Телефон:</label>
              <input type="tel" value={contactPhone} onChange={(e) => setContactPhone(e.target.value)} required />

              <label>Основное изображение:</label>
              {mainImage && (
                <div className="image-item">
                  <img
                    src={typeof mainImage === 'string' ? `/uploads/${mainImage}` : URL.createObjectURL(mainImage)}
                    alt="Основное изображение"
                    className="thumbnail"
                  />
                  <button type="button" onClick={handleRemoveMainImage}>Х</button>
                </div>
              )}
              <input type="file" accept="image/*" onChange={(e) => setMainImage(e.target.files[0])} />

              <label>Дополнительные изображения:</label>
              <input type="file" accept="image/*" multiple onChange={handleAddNewImages} />

              <div className="image-gallery">
                {images.map((image, index) => (
                  <div key={index} className="image-item">
                    <img
                      src={typeof image === 'string' ? `/uploads/${image}` : URL.createObjectURL(image)}
                      alt={`Изображение ${index + 1}`}
                      className="thumbnail"
                    />
                    <button class="button" onClick={() => handleRemoveExistingImage(index)}>X</button>
                  </div>
                ))}
                {newImages.map((image, index) => (
                  <div key={`new-${index}`} className="image-item">
                    <img
                      src={URL.createObjectURL(image)}
                      alt={`Новое изображение ${index + 1}`}
                      className="thumbnail"
                    />
                    <button type="button" onClick={() => setNewImages(newImages.filter((_, i) => i !== index))}>Удалить</button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'prices' && (
            <div className="tab-content">
              <h3>Цены:</h3>
              {Object.keys(prices).map((key) => (
                <div key={key}>
                  <label>{priceLabels[key]}:</label>
                  <input
                    type="number"
                    value={prices[key]}
                    onChange={(e) =>
                      setPrices({ ...prices, [key]: e.target.value })
                    }
                    required
                  />
                </div>
              ))}
            </div>
          )}

          {activeTab === 'characteristics' && (
            <div className="tab-content">
              <h3>Характеристики:</h3>
              {Object.keys(characteristics).map((key) => (
                <div key={key}>
                  <label>{characteristicLabels[key] || key}:</label>
                  <input
                    type="text"
                    value={characteristics[key]}
                    onChange={(e) =>
                      setCharacteristics({ ...characteristics, [key]: e.target.value })
                    }
                  />
                </div>
              ))}
            </div>
          )}
          {activeTab === 'preferences' && (
            <div>
              <h3> Основное и Дополнительно:</h3>
              {preferenceOptions.map((pref) => (
                <div key={pref.category} className="preference-group">
                  <h4>{pref.category}</h4>
                  {pref.options.map((option) => (
                    <div key={option} className="preference-option">
                      <label>
                        <div className="switch">
                          <input
                            type="checkbox"
                            checked={(preferences[pref.category]?.options || []).includes(option)}
                            onChange={() => handlePreferenceChange(pref.category, option)}
                          />
                          <span className="slider"></span>
                        </div>
                        {option}
                      </label>
                      <input
                        type="number"
                        placeholder="Цена"
                        value={
                          preferences[pref.category]?.prices?.[option] || ''
                        }
                        onChange={(e) =>
                          setPreferences((prevState) => {
                            const updatedCategory = prevState[pref.category] || { options: [], prices: {} };
                            return {
                              ...prevState,
                              [pref.category]: {
                                ...updatedCategory,
                                prices: {
                                  ...updatedCategory.prices,
                                  [option]: e.target.value,
                                },
                              },
                            };
                          })
                        }
                        className="price-input"
                      />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}


          <button type="submit" className="glow-on-hover2">Сохранить изменения</button>
          {message && <p>{message}</p>}
        </form>
        <button className="glow-on-hover2" onClick={onClose}>Закрыть</button>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.getElementById('modal-root'));
};

export default EditProductModal;
